import { ClockIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TWclassNames } from "../../utils/Div";
import { toast } from "react-hot-toast";
import HistoriesModal from "./modal";

export const HistoriesModalButton = (props) => {
  const { t } = useTranslation();
  const {
    module_param = "",
    module = "",
    entityMeta,
    /** "icon" = toolbar (default), "card" = full-width row like dashboard report actions */
    buttonLayout = "icon",
    /** Extra classes for the default icon button (project header uses pv-btn). */
    buttonClassName = "",
  } = props;
  const [open, setOpen] = useState(false);

  function handleOpenDialog() {
    if (!module_param || !module) {
      toast.error(
        "Module && Module Param  missing. Can't fetch or create histories."
      );
    } else {
      setOpen((v) => !v);
    }
  }

  const valid = Boolean(module_param && module);
  const isCard = buttonLayout === "card";
  const isLink = buttonLayout === "link";

  return (
    <>
      <button
        onClick={handleOpenDialog}
        type="button"
        className={TWclassNames(
          "transition",
          isLink
            ? "pv-link border-0 bg-transparent p-0 shadow-none"
            : isCard
            ? TWclassNames(
                "flex w-full items-center gap-3 rounded-2xl border px-4 py-3 text-left",
                valid
                  ? "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
                  : "border-red-200 bg-red-50 hover:bg-red-100"
              )
            : TWclassNames(
                buttonClassName ||
                  "inline-flex items-center justify-center rounded-xl border p-2.5 shadow-sm",
                valid
                  ? buttonClassName
                    ? ""
                    : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-800"
                  : "border-red-300 bg-red-50 text-red-700 hover:bg-red-100"
              )
        )}
        title={t("histories.title")}
      >
        {isLink ? (
          props.label || t("project.overview.activity.see_all")
        ) : isCard ? (
          <>
            <div
              className={TWclassNames(
                "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl",
                valid ? "bg-slate-100 text-slate-700" : "bg-red-100 text-red-700"
              )}
            >
              <ClockIcon className="h-5 w-5" aria-hidden />
            </div>
            <div className="min-w-0 text-left">
              <div className="text-sm font-semibold text-slate-900">
                {t("histories.title")}
              </div>
              <div className="text-xs text-slate-500">{t("histories.subtitle")}</div>
            </div>
          </>
        ) : (
          <>
            <ClockIcon className="h-5 w-5" aria-hidden />
            <span className="sr-only">{t("histories.title")}</span>
          </>
        )}
      </button>

      <HistoriesModal
        open={open}
        onClose={() => setOpen(false)}
        module={module}
        module_param={module_param}
        entityMeta={entityMeta}
      />
    </>
  );
};
